// @see https://blog.teknkl.com/destyle-a-marketo-form/
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeMarketoFormStyles = (marketoForm: any) => {
  const formEl = marketoForm.getFormElem()[0];

  // remove element styles from <form> and children
  const styledEls = Array.from(formEl.querySelectorAll('[style]')).concat(formEl) as Element[];

  styledEls.forEach(el => {
    el.removeAttribute('style');
  });

  // disable remote stylesheets and local <style>s
  const styleSheets = Array.from(document.styleSheets) as CSSStyleSheet[];

  styleSheets.forEach(styleSheet => {
    let mktoForms2ThemeStyle;
    let mktoForms2BaseStyle;

    if (
      [mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(styleSheet.ownerNode as unknown as undefined) !== -1 ||
      formEl.contains(styleSheet.ownerNode)
    ) {
      styleSheet.disabled = true;
    }
  });
};

export default removeMarketoFormStyles;
